export default "__VITE_ASSET__50699fc5__"